import { useEffect } from 'react';

import { googleTagManagerConfig } from '../../../config/googleTagManagerConfig';
import { ensureGTMScriptAdded } from './ensureGTMScriptAdded';
import { isGTMScriptLoaded } from './isGTMScriptLoaded';
import { removeGTMScript } from './removeGTMScript';

/* Be sure you place it once in the application */
export const useGoogleTagManagerScript = (activated: boolean) => {
  useEffect(() => {
    if (activated) {
      ensureGTMScriptAdded((value) => isGTMScriptLoaded.set(value));
    } else {
      removeGTMScript();
      console.log(`GTM disabled for "${googleTagManagerConfig.gtmMeasurementId}"`);
    }
  }, [activated]);
};
